<template>
	<Modals
		class="impact-form-prompt-order-modal"
		:title="'Change Prompt Order'"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="cancelAction"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="prompt-order">
				<FieldPromptDragableList
					v-model="inputFieldsData"
					:editMode="false"
					v-if="display"
					:mapping="fieldPromptMapping"
				/>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup
				:items="[
					{
						id: 'saveButtonModal',
						className: 'btn--primary',
						labelText: 'Save Changes',
						type: 'submit',
						btnClick: saveAction,
						disabled: !pendingChanges
					},
					{
						id: 'cancelButtonModal',
						className: 'btn--link',
						labelText: 'Cancel',
						btnClick: cancelAction
					}
				]"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import ButtonGroup from '@/components/forms/button/button-group';
import FieldPromptDragableList from '@/views/form-designer/field-prompt-draggable-list.vue';

export default {
	name: 'PromptOrderModal',
	components: {
		Modals,
		ButtonGroup,
		FieldPromptDragableList
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		inputFields: {
			type: Array,
			default: () => []
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			inputFieldsData: [],
			pendingChanges: false,
			fieldPromptMapping: {
				name: 'keyboardPrompt',
				order: 'order',
				id: 'formsKeyboardFieldsId'
			}
		};
	},
	computed: {
		isConfirmation() {
			return this.type == 'confirmation';
		},
		isMobile() {
			return this.$store.getters.screenSize.mobile;
		}
	},
	methods: {
		saveAction() {
			this.$emit('change', this.inputFieldsData);
			this.cancelAction();
		},
		cancelAction() {
			this.pendingChanges = false;
			this.$emit('show', false);
		}
	},
	watch: {
		display: {
			handler(val) {
				if (val) {
					this.inputFieldsData = [...this.inputFields];
					this.$nextTick(() => {
						this.pendingChanges = false;
					});
				}
			}
		},
		inputFieldsData: {
			deep: true,
			handler() {
				this.pendingChanges = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Impact Form Prompt Order Modal
    * Can use SCSS variables = TRUE
*/

::v-deep .form-designer-content__input-fields {
	padding: 0;
	margin-top: -24px;
}

::v-deep .form-designer-content .drag-drop {
	&__header {
		margin-top: $gutter-xl;
	}

	&__body {
		max-height: initial;
	}

	&__list-item-btn {
		display: flex;
	}
}

::v-deep .form-field-prompt {
	display: flex;

	@include mq($from: md) {
		display: grid;
		grid-template-columns: auto auto;
	}

	&__content-primary {
		width: 100%;

		@include mq($from: sm-l) {
			justify-content: space-between;
		}

		&-prompt {
			margin: $gutter-lg 0 0 0;

			@include mq($from: sm-l) {
				margin: 0;
			}
		}
	}

	&__content-field-text {
		@include mq($from: sm-l) {
			max-width: 240px;
		}
	}
}

::v-deep .form-field-prompt__content-primary-prompt .dropdown {
	display: flex;
	flex-direction: row;
	align-items: center;

	&__label {
		display: flex;
		margin-bottom: 0;
		min-width: fit-content;
	}

	&__input-container {
		display: flex;
		margin-left: $gutter-md;
		min-width: 80px;
	}
}
</style>
